import React, { useSyncExternalStore } from 'react';

// Overlay activity must not trigger a dashboard render and redraw every plot.
export function createOverlayVisibilityStore() {
  let visible = true;
  const listeners = new Set();
  return {
    getSnapshot: () => visible,
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    set(next) {
      if (visible === next) return;
      visible = next;
      listeners.forEach(listener => listener());
    },
  };
}

export default function CanvasOverlayVisibility({ store, children, className }) {
  const visible = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
  return React.cloneElement(children, className
    ? { className: `${className}${visible ? ' is-visible' : ''}` }
    : { isVisible: visible });
}
